import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { useNavigate } from "react-router-dom";
import { fetchAdViewsByUserType } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import LoadingSpinner from "../../../Components/spinner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdViewsPerUser() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  const getAdViewsByUserType = async () => {
    const res = await fetchAdViewsByUserType();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (userType) {
        const temp = res?.data?.data?.filter((f) => f.user_type === userType);
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigate);
    }
    setFetching(false);
  };

  const handleFilterChange = (e) => {
    setUserType(e.target.value);
    if (e.target.value) {
      const temp = tableData?.filter((f) => f.user_type === e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };
  const handleReset = () => {
    setUserType("");
    setFilteredData(tableData);
  };

  const chartData = {
    labels: filteredData?.map((item) => item?.user_type?.toUpperCase()),
    datasets: [
      {
        label: "Average Ads Watched",
        data: filteredData.map((item) => parseInt(item.avg_ads_per_user)),
        backgroundColor: filteredData.map((item) =>
          item.userType === "guest"
            ? "rgba(255, 99, 132, 0.6)"
            : "rgba(54, 162, 235, 0.6)"
        ),
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "#ffffff" },
      },
      y: {
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getAdViewsByUserType();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item.user_type, item.total_ads_watched, item.avg_ads_per_user];
    });

    const config = {
      data: rows,
      columns: [
        { title: "User Type" },
        { title: "Total Ads" },
        { title: "Avg. Ads" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Section */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={userType}
                onChange={handleFilterChange}
              >
                <option value="">All user types</option>
                <option value="guest">Guest</option>
                <option value="registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              {fetching ? (
                <LoadingSpinner size="small" />
              ) : (
                <Button variant="success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Views per User</h5>
          <p className="card-text">
            Average number of ads watched per user (guest vs. registered).
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Section */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Average Ads Watched by User Type</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdViewsPerUser;
